module.exports = __webpack_public_path__ + "static/img/18.18c8c988.png";